import type { MacroregionName } from '~/config/cities';

import { CITIES, MACROREGIONS, STATE_CODES } from '~/config/cities';

import { MacroregionIdentifier } from './types';

const nameToIdMap: Record<string, MacroregionIdentifier> = {
	// Macroregions by display name
	[MACROREGIONS.INTERIOR]: MacroregionIdentifier.INTERIOR,
	[MACROREGIONS.LITORAL_NORTE]: MacroregionIdentifier.LITORAL_NORTE,
	[MACROREGIONS.LITORAL_SUL]: MacroregionIdentifier.LITORAL_SUL,
	[MACROREGIONS.ALPHAVILLE]: MacroregionIdentifier.ALPHAVILLE,
	// City mapping (São Paulo city acts as macroregion São Paulo)
	[CITIES.SAO_PAULO.name]: MacroregionIdentifier.SAO_PAULO,
	[CITIES.CURITIBA.name]: MacroregionIdentifier.CURITIBA
} as const;

/**
 * Map of cities that are also macroregions
 * Used to determine automatically the macroregion when a city is selected
 */
const cityToMacroregionMap: Record<string, MacroregionName> = {
	[CITIES.SAO_PAULO.name]: MACROREGIONS.SAO_PAULO,
	[CITIES.CURITIBA.name]: MACROREGIONS.CURITIBA
} as const;

const macroregionToStateMap: Record<string, string> = {
	[MACROREGIONS.INTERIOR]: STATE_CODES.SAO_PAULO,
	[MACROREGIONS.LITORAL_NORTE]: STATE_CODES.SAO_PAULO,
	[MACROREGIONS.LITORAL_SUL]: STATE_CODES.SAO_PAULO,
	[MACROREGIONS.ALPHAVILLE]: STATE_CODES.SAO_PAULO,
	[CITIES.SAO_PAULO.name]: STATE_CODES.SAO_PAULO,
	[CITIES.CURITIBA.name]: STATE_CODES.PARANA
} as const;

export function mapMacroregionNameToIdentifier(
	name: string | undefined | null
): MacroregionIdentifier | undefined {
	if (!name) return undefined;
	return nameToIdMap[name] as MacroregionIdentifier | undefined;
}

/**
 * Maps macroregion name to state abbreviation
 * Used when API doesn't provide states in the response
 */
export function mapMacroregionToState(
	macroregion: string | undefined | null
): string {
	if (!macroregion) return STATE_CODES.SAO_PAULO;
	return macroregionToStateMap[macroregion] || STATE_CODES.SAO_PAULO;
}

/**
 * Check if a city is also a macroregion and return the corresponding macroregion
 * Used to determine automatically the macroregion when a city like "Curitiba" or "São Paulo" is selected
 * @param cityName - City name
 * @returns The corresponding macroregion or undefined if the city is not a macroregion
 */
export function getCityAsMacroregion(
	cityName?: string
): MacroregionName | undefined {
	if (!cityName) return undefined;
	return cityToMacroregionMap[cityName];
}
